import { NavLink } from 'react-router-dom';
import { t } from '../i18n';

const Navigation = () => {

  // Restart animations on change so flashing stays in sync across tabs.
  return (
    <nav className="sidenav">
      <NavLink to="/language" className={({ isActive }) => isActive ? 'sidetab active' : 'sidetab'}>
          <svg xmlns="http://www.w3.org/2000/svg" className="sidetab-logo" viewBox="0 0 640 640"><title>{t('language')}</title><path fill="currentColor" d="M192 64c17.7 0 32 14.3 32 32v32h128c17.7 0 32 14.3 32 32s-14.3 32-32 32h-9.6l-8.4 23.1c-16.4 45.2-41.1 86.5-72.2 122c14.2 8.8 29 16.6 44.4 23.5l50.4 22.4l62.2-140c5.1-11.6 16.6-19 29.2-19s24.1 7.4 29.2 19l128 288c7.2 16.2-.1 35.1-16.2 42.2s-35.1-.1-42.2-16.2l-20-45H369.3l-20 45c-7.2 16.2-26.1 23.4-42.2 16.2s-23.4-26.1-16.2-42.2l39.8-89.5l-50.4-22.4c-23-10.2-45-22.4-65.8-36.4c-21.3 17.2-44.6 32.2-69.5 44.7l-34.7 17.2c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l34.5-17.3c16.3-8.2 31.8-17.7 46.4-28.3c-13.8-12.7-26.8-26.4-38.9-40.9l-10.1-12.2c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l10.2 12.2c11.5 13.9 24.1 26.8 37.4 38.7c27.5-30.4 49.2-66.1 63.5-105.4l.5-1.2H64.1C46.3 192 32 177.7 32 160s14.3-32 32-32h96V96c0-17.7 14.3-32 32-32m256 270.8L397.7 448h100.6z"/></svg>
      </NavLink>
      <NavLink to="/about" className={({ isActive }) => isActive ? 'sidetab active' : 'sidetab'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="sidetab-logo"
        viewBox="0 0 48 48"
        aria-hidden="true"
      >
        <title>{t('about')}</title>

        <path
          fill="currentColor"
          d="M24.3,6A11.2,11.2,0,0,0,16,9.3a11,11,0,0,0-3.5,8.2,2.5,2.5,0,0,0,5,0,6.5,6.5,0,0,1,2-4.7A6.2,6.2,0,0,1,24.2,11a6.5,6.5,0,0,1,1,12.9,4.4,4.4,0,0,0-3.7,4.4v3.2a2.5,2.5,0,0,0,5,0V28.7a11.6,11.6,0,0,0,9-11.5A11.7,11.7,0,0,0,24.3,6Z"
        />

        <circle
          fill="currentColor"
          cx="24"
          cy="39.5"
          r="2.5"
        />
      </svg>
      </NavLink>
    </nav>
  );
};

export default Navigation;